export const SET_DUMMY_TYPE = "SET_DUMMY_TYPE";
export const SET_STAT_TYPE = "SET_STAT_TYPE";
export const SET_WALLET_TYPE = "SET_WALLET_TYPE";